import { createTicket } from "library/api/zendesk/zendesk";
import { getIsProduction } from "library/browser";
import { closeAccountFieldsAU } from "./customFieldsMap";
import {
  closeAccountFieldsNZ,
  nzProducts,
  reasonOptionValues,
} from "./customFieldsMap/closeAccountCustomFieldsMap";
import { formatDate } from "./zendeskAPI";

const GROUP_ID_AU = { prod: 360002312898, nonProd: 360004390118 };
const GROUP_ID_NZ = { prod: 360002369658, nonProd: 360004390538 };

const FORM_ID_AU = { prod: 360000140718, nonProd: 360000233497 };
const FORM_ID_NZ = { prod: 360000136417, nonProd: 360000234037 };

export async function createCloseAccountTicket({
  userName,
  reason,
  otherInfo,
  email,
  firstName,
  lastName,
  dateOfBirth,
  mobileNumber,
  last4digits,
  confirmationLetter,
  isNZ,
  productName,
  token,
}) {
  const isProduction = getIsProduction();
  const envKey = isProduction ? "prod" : "nonProd";
  const productValue = isNZ
    ? nzProducts[productName]?.[envKey] ?? ""
    : "product_type_credit_card";

  const ticketResponse = await createTicket(
    {
      isNZ,
      requester: {
        name: userName,
        email,
      },
      ticketFormId: isNZ ? FORM_ID_NZ[envKey] : FORM_ID_AU[envKey],
      groupId: isNZ ? GROUP_ID_NZ[envKey] : GROUP_ID_AU[envKey],
      subject: "Close My Account",
      comment:
        "Close account request originating from the Latitude Service Centre (LSC).",
      customFields: [
        {
          id: closeAccountFieldsAU["Account closure reason"],
          value: reasonOptionValues[reason][envKey],
        },
        {
          id: closeAccountFieldsAU["Other Information"],
          value: otherInfo,
        },
        {
          id: closeAccountFieldsAU["Customers first name"],
          value: firstName,
        },
        {
          id: closeAccountFieldsAU["Surname  (as it appears on ID)"],
          value: lastName,
        },
        {
          id: closeAccountFieldsAU["Relationship to account"],
          value: "account_holder",
        },
        {
          id: closeAccountFieldsAU.DOB,
          value: formatDate(dateOfBirth),
        },
        {
          id: closeAccountFieldsAU["Mobile Number"],
          value: mobileNumber,
        },
        {
          id: closeAccountFieldsAU["Last 4 digits"],
          value: last4digits,
        },
        {
          id: closeAccountFieldsAU["Copy required? "],
          value: confirmationLetter,
        },
        {
          id: closeAccountFieldsAU["Outstanding Balance"],
          value: "no_account_close",
        },
        {
          id: closeAccountFieldsAU["Direct debit and insurance cancelled"],
          value: true,
        },
        {
          id: closeAccountFieldsAU["Liable for unposted purchases"],
          value: true,
        },
        {
          id: closeAccountFieldsAU["Cannot reopen account"],
          value: true,
        },
        {
          id: closeAccountFieldsAU["Privacy Acknowledgement"],
          value: true,
        },
        {
          id: isNZ
            ? closeAccountFieldsNZ["Product NZ "]
            : { prod: "NA", nonProd: "NA" }, // TODO product field in AU needs to be checked.
          value: productValue,
        },
      ],
    },
    token,
  );

  return ticketResponse.data.ticket_id;
}
